import { render, staticRenderFns } from "./QuantityVoucherSoldOfStaffInAgent.vue?vue&type=template&id=526be662&scoped=true&"
import script from "./QuantityVoucherSoldOfStaffInAgent.vue?vue&type=script&lang=js&"
export * from "./QuantityVoucherSoldOfStaffInAgent.vue?vue&type=script&lang=js&"
import style0 from "./QuantityVoucherSoldOfStaffInAgent.vue?vue&type=style&index=0&id=526be662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526be662",
  null
  
)

export default component.exports